import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { moduleApprover, moduleRequestor } from 'src/app/modules/shared/common/api';
import { UserIdleService } from 'angular-user-idle';

@Component({
  selector: 'ark-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  _user: any;
  myControl = new FormControl();
  options: any[];
  filteredOptions: Observable<string[]>;


  constructor( 
    private auth: AuthService,
    private _router: Router,
    private userIdle: UserIdleService,
  ) { }

  ngOnInit() {
    this._user = new User(this.auth.getAuthUser());
    if (this._user.role_name == "Requestor") {
      this.options = moduleRequestor;
    } else  {
      this.options = moduleRequestor.concat(moduleApprover);
    }
    this.filteredOptions = this.myControl.valueChanges
    .pipe(startWith(''),map(value => value.length >= 1 ? this._filter(value): []));
  }

  logout() {
    let data = {
      token: this._user.token
    }
    this.auth.logout(data).subscribe(res =>{
        this.userIdle.stopWatching();
        localStorage.removeItem('cashUser');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('token');
        this._router.navigate(["/login"]);
    },(err => {
      if (err.status == 401) {
        window.location.reload();
      }
    }));
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  navigetUrl(url:string) {
    this._router.navigate([url]);
  }
}
